module.exports = __webpack_public_path__ + "static/img/image_j_apple.d86bc9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_j_apple.jpg
// module id = w4k6
// module chunks = 1